import { IHttpApi } from '@cian/http-api';

import { assertResponseBody, assertResponseStatus } from './asserts';
import {
  fetchPrebookOffer,
  IPrebookOfferRequest,
  IPrebookOfferResponse200,
  IPrebookOfferResponse400,
} from '../../repositories/profitbase-booking/v1/prebook-offer';

export const fetchProfitbaseBooking = async (httpApi: IHttpApi, parameters: IPrebookOfferRequest): Promise<string> => {
  const response = await fetchPrebookOffer<IPrebookOfferResponse200, IPrebookOfferResponse400>({ httpApi, parameters });

  assertResponseStatus(response);
  assertResponseBody(response);

  return response.response.profitbaseLkUrl;
};
